exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".country-selection .toggler{outline:none;text-decoration:none!important;display:flex;align-items:center;justify-content:center}.country-selection .vs-select--input{font-size:13px}[dir] .country-selection .parent-dropdown{cursor:pointer}", ""]);

// exports
